import { fetchSelectionListProducts } from './apiFetchSelectionListProducts';
import { useQuery } from '@tanstack/react-query';
import { ProductFilter } from '../../../../models/Product';
import { Pagination } from '../../../../models/Pagination';
import { browserClient } from '../../../react-query';

interface PropTypes {
    filterMap: ProductFilter;
    pagination: Pagination;
    listId: string;
    groupId: string | null;
    groupType: string;
}

const SELECTION_LIST_PRODUCTS_QUERY_KEY = 'selectionListProducts';

export const useSelectionListProducts = (props: PropTypes) => {
    const { filterMap, pagination, listId, groupType, groupId } = props;
    const transformedFilterMap = JSON.stringify(filterMap);
    const queryResult = useQuery(
        [
            SELECTION_LIST_PRODUCTS_QUERY_KEY,
            listId,
            { filterMap: transformedFilterMap, ...pagination, groupType, groupId }
        ],
        () => fetchSelectionListProducts({ filterMap: transformedFilterMap, pagination, listId, groupType, groupId })
    );

    const { data: selectionListProducts } = queryResult;
    return {
        ...queryResult,
        products: {
            count: selectionListProducts?.totalHits ?? 0,
            list: selectionListProducts?.hits ?? []
        }
    };
};

export const invalidateSelectionListProducts = (listId: string) => {
    return browserClient.invalidateQueries([SELECTION_LIST_PRODUCTS_QUERY_KEY, listId]);
};
